import builder from '@builder.io/react';
import { ALL_LOCALES, localifyLink } from '../../../../helpers/LangHelper';
import { getCommonPageDetails } from '../../../../shared/commonPageDetails';

export async function getStaticProps(context: any) {
    const { lang, business } = context.params;
    let pageSlug = `/${business}/access/guides`;

    let page = await builder
        .get('page', {
            userAttributes: {
                urlPath: `/business/access/guides`,
                locale: [lang],
            },
        })
        .toPromise();

    if (!page) {
        page = await builder
            .get('page', {
                userAttributes: {
                    urlPath: `/for-retailers/access/guides`,
                    locale: [lang],
                },
            })
            .toPromise();
    }

    const { footerItems, categories, canonicalUrl } = await getCommonPageDetails(pageSlug, context.params.lang, page);

    return {
        props: { page: page ?? null, footerItems, categories, canonicalUrl },
        revalidate: 3600,
    };
}

export async function getStaticPaths() {
    const allPaths: string[] = [];

    ALL_LOCALES.forEach((locale) => {
        allPaths.push(localifyLink(`/${locale}/business/access/guides`, locale));
    });

    return {
        paths: allPaths,
        fallback: false,
    };
}

export { default } from '../../../[...slug]';
